export const LEGEND = 'LEGEND';
export const DROP = 'DROP';
export const PLACE = 'PLACE';



// WEBPACK FOOTER //
// ./src/enum/map-stat-types.enum.js